<template>
	<div class="price-info-area">
		<div v-if="typeof lodging.price === 'undefined'" class="price">
			<template v-if="fromPriceDisplay !== '0' && fromPriceDisplay !== ''">{{translations.sentences.fromPrice}} <span class="highlight" itemprop="priceRange" :content="fromPriceDisplay">{{fromPriceDisplay}} {{currencyDisplay}}</span><template v-if="fromFeePriceDisplay !== false"><br><span class="fromFeePrice">{{fromFeePriceDisplay}}</span></template></template>
			<template v-else><span class="not-available">{{translations.terms.notAvailable}}</span></template>
		</div>
		<div v-else-if="lodging.price.price !== lodging.price.normalPrice" class="price lastMinutePrice">
			<div class="lastMinuteBefore">
				{{translations.terms.before}} <span class="linethrough">{{normalPrice}} {{currencyDisplay}}</span>
			</div>
			<div class="lastMinuteTotal">
				{{translations.terms.now}} {{priceDisplay}} {{currencyDisplay}}
			</div>
			<div class="lastMinuteSave">
				{{translations.terms.save}} {{savePriceDisplay}} {{currencyDisplay}}
			</div>
			<span v-if="feePriceDisplay !== false" class="fromFeePrice">{{feePriceDisplay}}</span>
		</div>
		<div v-else class="price">
			<span class="highlight" itemprop="priceRange" :content="priceDisplay">{{priceDisplay}} {{currencyDisplay}}</span>
			<template v-if="feePriceDisplay !== false"><br><span class="fromFeePrice">{{feePriceDisplay}}</span></template>
		</div>
		<div v-if="typeof lodging.additionals !== 'undefined' && lodging.additionals.length > 0" class="additionals-text right">{{translations.sentences.additionalArrivalDates}}</div>
		<a :href="parsedUrl" class="orange-btn base-btn orange-glossy-gradient "><i class="cfa cfa-info"><img :src="infoIconUrl" /></i> {{translations.sentences.viewMore}}</a>
	</div>
</template>

<script>
	import {mapState} from 'vuex';
	export default {
		computed: {
			...mapState({
				translations: 'translations',
				svgIconUrl: 'svgIconUrl'
			}),
			parsedUrl(){
				if(window.isDev)
					return this.lodging.url.replace('https://esmark.dk','http://esmarklocal.dk');

				if(window.location.hostname === 'vesterland.dk')
					return this.lodging.url.replace('esmark.dk','vesterland.dk');

				if(window.location.hostname === 'westerland.dk')
					return this.lodging.url.replace('esmark.de','westerland.dk');

				return this.lodging.url;
			},
			fromPriceDisplay(){
				let price = this.lodging.postMeta.esFromPrice;
				if(parseInt(price) !== 0 && typeof this.lodging.postMeta.esFromFeePrice !== 'undefined')
					price = parseInt(price)+parseInt(this.lodging.postMeta.esFromFeePrice);

				return this.placeCharXFromEnd(price,3);
			},
			fromFeePriceDisplay(){
                if(siteID !== '2')
                    return false;

				return typeof this.lodging.postMeta.esFromFeePrice !== 'undefined' && this.lodging.postMeta.esFromFeePrice !== '' && this.lodging.postMeta.esFromFeePrice !== 0 ? this.translations.sentences.feePrice.replace('%s',this.placeCharXFromEnd(this.lodging.postMeta.esFromFeePrice,3) +' '+this.currencyDisplay) : false;
			},
			infoIconUrl(){
				return (siteID === '1') ? this.svgIconUrl + 'tab-info_dk.svg' : this.svgIconUrl + 'tab-info_de.svg';
			},
			currencyDisplay(){
				return siteCurrencyDisplay;
			},
			savePriceDisplay(){
				return this.placeCharXFromEnd(this.lodging.price.normalPrice - this.lodging.price.price,3);
			},
			priceDisplay(){
				let price = this.lodging.price.price;
				if(typeof this.lodging.price.feePrice !== 'undefined')
					price = parseInt(price)+parseInt(this.lodging.price.feePrice);

				return this.placeCharXFromEnd(price,3);
			},
			feePriceDisplay(){
                if(siteID !== '2')
                    return false;

                return typeof this.lodging.price !== 'undefined' && typeof this.lodging.price.feePrice !== 'undefined' && this.lodging.price.feePrice !== '' && this.lodging.price.feePrice !== 0 ? this.translations.sentences.feePrice.replace('%s',this.placeCharXFromEnd(this.lodging.price.feePrice,3) + ' ' + this.currencyDisplay) : false;
			},
			normalPrice(){
				return this.placeCharXFromEnd(this.lodging.price.normalPrice,3);
			}
		},
		methods: {
			placeCharXFromEnd: function (value, offset) {
				if (!value) return '';
				value = value.toString();
				offset = typeof offset === 'undefined' ? 0 : offset ;
				if(value.length <= offset) return value;
				const pos = value.length - offset;
				return value.slice(0, pos)+'.'+value.slice(pos)
			}
		},
		props:{
			lodging: Object
		},
	}
</script>

<style scoped>

</style>
